/// <amd-module name="CodeCoverage/CodeCoverageTab/Components/BuildConfigSelector" />
import { CodeCoverageTabActionCreator } from 'Actions/CodeCoverageTabActionCreator';
import { CodeCoverageTabActionHub } from 'Actions/CodeCoverageTabActionHub';
import * as Resources from 'CodeCoverage/CodeCoverageTab/Resources';
import * as React from 'react';
import { BuildConfigSelectorStore, IBuildConfigItem, IBuildConfigSelectorState } from 'Stores/BuildConfigSelectorStore';
import * as TCMContracts from 'Test/common-util/Contracts/Test';
import { VssComponent, IVssComponentContext } from 'VSS/Platform/Layout';
import { IPickListSelection, PickListDropdown } from 'VSSUI/PickList';


export interface IBuildConfigSelectorProps {
    configurations: TCMContracts.BuildConfiguration[];
}

export class BuildConfigSelector extends VssComponent<IBuildConfigSelectorProps, IBuildConfigSelectorState> {
    private _actionCreator: CodeCoverageTabActionCreator;
    private _actionHub: CodeCoverageTabActionHub = CodeCoverageTabActionHub.getInstance();
    private _buildSelectorStore: BuildConfigSelectorStore;
	private readonly ConfigSelectionChangeEvent = "configSelectionChangeEvent";

    constructor(props: IBuildConfigSelectorProps, context: IVssComponentContext) {
        super(props);

        const pickListItems = this._generatePickListItems();
        this._actionCreator = CodeCoverageTabActionCreator.getInstance(context);

        this.state = {
            buildConfigurationList: pickListItems,
            selectedConfiguration: pickListItems[0]
        } as IBuildConfigSelectorState;
    }

    componentWillMount() {
        this._buildSelectorStore = new BuildConfigSelectorStore(this.ConfigSelectionChangeEvent, this._actionHub, this.state);
        this._buildSelectorStore.addChangedListener(this._onStoreStateChanged);
    }

    componentDidUpdate(prevProps: IBuildConfigSelectorProps) {
        if (this.props.configurations !== prevProps.configurations) {
            const changedPickListItems = this._generatePickListItems();
            this.state = {
                buildConfigurationList: changedPickListItems,
                selectedConfiguration: changedPickListItems[0]

            } as IBuildConfigSelectorState
        }
    }

    componentWillUnmount() {
        this._buildSelectorStore.removeChangedListener(this._onStoreStateChanged);
    }

    private _generatePickListItems(): IBuildConfigItem[] {
        if(!this.props.configurations.length) {
            return [this._getIBuildConfigItem(0)];
        }
        return this.props.configurations.map((config, index) => this._getIBuildConfigItem(index, config.flavor, config.platform));
    }

    private _getIBuildConfigItem(index: number, flavor?: string, platform?: string): IBuildConfigItem {
        const buildFlavor = `${Resources.BuildConfigurationText}:  ${ flavor || Resources.EmptyLiteralText }`;
        const buildPlatform = `${Resources.BuildPlatformText}:  ${ platform || Resources.EmptyLiteralText }`;
        const selectorText = `${buildFlavor} | ${buildPlatform}`;

        return {
            index: index,
            name: selectorText
        } as IBuildConfigItem;
    }

    public render(): JSX.Element {
        return (
            <div className="build-config-selector">
                <PickListDropdown
                    className="build-config-picklist"
                    getListItem={(item: IBuildConfigItem) => {
                        return {
                            key: item.index.toString(),
                            name: item.name
                        };
                    }}
                    initiallySelectedItems={[this.state.selectedConfiguration]}
                    getPickListItems={() => this.state.buildConfigurationList}
                    onSelectionChanged={(selection: IPickListSelection) => {
                        this._updateSelectionInBuildCodeCoverage(selection)
                    }}
                />
            </div>
        );
    }

    private _updateSelectionInBuildCodeCoverage(selection: IPickListSelection) {
        this._actionCreator.updateBuildConfigSelection(selection.selectedItems[0].index);
    }

    
	private _onStoreStateChanged = ()  => { 
		this.setState(this._buildSelectorStore.getState());
	}
}
